// extracted by mini-css-extract-plugin
export var active = "_91-c";
export var activeIndicator = "_91-7";
export var animate = "_91-b";
export var contentWidthTabs = "_91-5";
export var disabled = "_91-d";
export var flat = "_91-1";
export var fullWidth = "_91-3";
export var lg = "_91-a";
export var md = "_91-9";
export var redoButtonTabGroup = "_91-0";
export var sm = "_91-8";
export var tabButton = "_91-4";
export var tabButtonsContainer = "_91-2";
export var xs = "_91-6";